import './PrimaryHeaderNav.scss';

import AuthModalButton from 'components/partials/auth-modal/components/auth-modal-button/AuthModalButton';
import Contacts from 'components/partials/contacts/Contacts';
import SignupModalButton from 'components/partials/signup-modal/components/signup-modal-button/SignupModalButton';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { connect } from 'react-redux';

import AboutUsNavGroup from './components/nav-groups/AboutUsNavGroup';
import BenefitsNavGroup from './components/nav-groups/BenefitsNavGroup';
import FaqNavGroup from './components/nav-groups/FaqNavGroup';
import GetEducatedNavGroup from './components/nav-groups/GetEducatedNavGroup';
import InsuranceNavGroup from './components/nav-groups/InsuranceNavGroup';
import { usePrimaryNav } from './hooks';

const propTypes = {
  // store
  userIsLoggedIn: PropTypes.bool
};

const PrimaryHeaderNav = ({ userIsLoggedIn }) => {
  const { ref, expanded, setExpanded } = usePrimaryNav();

  return (
    <Navbar
      ref={ref}
      collapseOnSelect
      expanded={expanded}
      onToggle={nextExpanded => {
        setExpanded(nextExpanded);
      }}
      variant="default"
      className="primary-navbar"
      expand="lg"
    >
      <Navbar.Toggle aria-controls="primary-navbar-collapse">
        <span className="sr-only">Toggle navigation</span>
        <span className="icon-bar top-bar"></span>
        <span className="icon-bar middle-bar"></span>
        <span className="icon-bar bottom-bar"></span>
      </Navbar.Toggle>
      <Contacts />
      <Navbar.Collapse id="primary-navbar-collapse">
        <Container className="primary-navbar-collapse-container">
          <Nav id="basic-nav-dropdown">
            <InsuranceNavGroup />
            <BenefitsNavGroup userIsLoggedIn={userIsLoggedIn} />
            <GetEducatedNavGroup />
            <AboutUsNavGroup />
            <FaqNavGroup />
          </Nav>
          {!userIsLoggedIn && <AuthModalButton />}
          {!userIsLoggedIn && <SignupModalButton />}
        </Container>
      </Navbar.Collapse>
    </Navbar>
  );
};

PrimaryHeaderNav.propTypes = propTypes;

const mapStateToProps = state => ({
  userIsLoggedIn: _get(state, 'user.isLoggedIn')
});

export default connect(mapStateToProps)(PrimaryHeaderNav);
